import { render, staticRenderFns } from "./visitList.vue?vue&type=template&id=3068df8f&"
import script from "./visitList.vue?vue&type=script&lang=js&"
export * from "./visitList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports